import React, { useState } from "react";
import { Modal, Form, Input, message } from "antd";
import { api } from "../../components/Api/api";

const ModalEditUserContact = ({ visible, onCancel, record, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (visible && record) {
      form.setFieldsValue({
        fullName: record.fullName,
        phoneNumber: record.phoneNumber,
        email: record.email,
        address: record.address,
        subject: record.subject,
        message: record.message,
      });
    }
  }, [visible, record, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await api.put(`api/v1/web-user-contact/${record.id}`, values);

      message.success("Cập nhật thành công");
      onSuccess();
      onCancel();
    } catch (error) {
      console.error("Error updating user contact:", error);
      message.error("Có lỗi xảy ra khi cập nhật");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Chỉnh sửa thông tin liên hệ"
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
      width={800}
    >
      <Form form={form} layout="vertical" initialValues={record}>
        <Form.Item
          name="fullName"
          label="Họ tên"
          rules={[{ required: true, message: "Vui lòng nhập họ tên" }]}
        >
          <Input placeholder="Nhập họ tên" />
        </Form.Item>

        <Form.Item
          name="phoneNumber"
          label="Số điện thoại"
          rules={[{ required: true, message: "Vui lòng nhập số điện thoại" }]}
        >
          <Input placeholder="Nhập số điện thoại" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[{ type: "email", message: "Email không hợp lệ" }]}
        >
          <Input placeholder="Nhập email" />
        </Form.Item>

        <Form.Item name="address" label="Địa chỉ">
          <Input placeholder="Nhập địa chỉ" />
        </Form.Item>

        <Form.Item name="subject" label="Tiêu đề">
          <Input placeholder="Nhập tiêu đề" />
        </Form.Item>

        <Form.Item name="message" label="Nội dung">
          <Input.TextArea placeholder="Nhập nội dung" rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalEditUserContact;
